import { render, staticRenderFns } from "./FeaturedContent3.vue?vue&type=template&id=2766eeeb&scoped=true"
import script from "./FeaturedContent3.vue?vue&type=script&lang=js"
export * from "./FeaturedContent3.vue?vue&type=script&lang=js"
import style0 from "./FeaturedContent3.vue?vue&type=style&index=0&id=2766eeeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2766eeeb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
